import { FC, useMemo } from 'react';

import dayjs from 'dayjs';
import useSWR from 'swr';

import Chip from '@mui/material/Chip';

import { rewardColorByStatus } from './constants';
import { CreateEntryRewardButton } from './createEntryRewardButton/CreateEntryRewardButton';
import { EntryRewardsTableActionsColumn } from './entryRewardsTableColumns/entryRewardsActionsColumn/EntryRewardsTableActionsColumn';
import { EntryRewardsNameColumn } from './entryRewardsTableColumns/entryRewardsNameColumn/EntryRewardsNameColumn';

import css from './EntryRewardPage.module.css';

import { entryRewardService } from 'v2/api/entryRewardService';
import { DataTable } from 'v2/components/dataTable/DataTable';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { TableColumn } from 'v2/types';
import { EntryRewardModel } from 'v2/types/RewardModel';

export const EntryRewardPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getEntryRewards', entryRewardService.getEntryRewards);

  const columns: TableColumn<EntryRewardModel>[] = useMemo(
    () => [
      {
        key: 'reward',
        label: 'Reward',
        render: (row) => <EntryRewardsNameColumn entryReward={row} />,
      },
      {
        key: 'status',
        label: 'Status',
        render: (row) => <Chip label={row.status} color={rewardColorByStatus[row.status]} size="small" />,
      },
      {
        key: 'activationDate',
        label: 'Activation Date',
        render: (row) => dayjs(row.activationDate).format('DD-MM-YYYY HH:mm'),
      },
      {
        key: 'expirationDate',
        label: 'Expiration Date',
        render: (row) => dayjs(row.expirationDate).format('DD-MM-YYYY HH:mm'),
      },
      {
        key: 'actions',
        align: 'right',
        render: (row) => <EntryRewardsTableActionsColumn entryReward={row} onRevalidate={mutate} />,
      },
    ],
    [mutate]
  );

  return (
    <PageLayout className={css.entryRewardPage}>
      <PageTitle action={<CreateEntryRewardButton onSuccess={mutate} />}>Entry Reward Settings</PageTitle>

      {isLoading ? <Loader /> : <DataTable columns={columns} data={data} />}
    </PageLayout>
  );
};
